import axios from 'axios';
import { toast } from 'react-toastify';


// TODO use .env
const axiosClient = axios.create({
    // baseURL: 'https://nilab-backend.onrender.com/api/v1', // replace with your backend
    baseURL: process.env.REACT_APP_ENV === 'production' ? process.env.REACT_APP_API_URL : 'http://localhost:7000/api/v1',
    headers: { 'Content-Type': 'application/json' },
    timeout: 30000 // 30 seconds
});

// ✅ Request interceptor → attach token
axiosClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    console.log('env', process.env.REACT_APP_ENV);
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// ✅ Response interceptor → handle expired/invalid token
axiosClient.interceptors.response.use(
    (response) => response, // unwrap the `data`
    (error) => {
        if (error.config?.skipGlobalToast) {
            return Promise.reject(error);
        }
        if (error.response && error.response.status === 401) {
            // clear storage
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            console.log(error.response.data?.code || 'Session expired. Please log in again.');

            //    if Vendor inactive, redirect to pending approval
            if (error.response.data?.code === 'VENDOR_INACTIVE') {
                window.location.href = '/vendor-pending-approval';
            } else {
                // redirect to login
                window.location.href = '/login';
            }
        } else {
            // Global error toast for other errors
            const message = error.response?.data?.message || error.message || 'An unexpected error occurred';
            toast.error(message);
        }
        return Promise.reject(error);
    }
);

export default axiosClient;
